'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _util = require('../util');

var _util2 = _interopRequireDefault(_util);

var _utils = require('./utils');

var _lodashCompat = require('lodash-compat');

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

/**
 * 头部导航栏，目前只能接受最多二级导航
 * FIXME hover出现用户菜单
 * FIXME 当导航栏宽度不够显示全部时出现更多
 */
var HeaderNav = (_temp = _class = function (_M$BaseComponent) {
  _inherits(HeaderNav, _M$BaseComponent);

  function HeaderNav(props) {
    _classCallCheck(this, HeaderNav);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(HeaderNav).call(this, props));

    Object.assign(_this.state, {
      showUserMenu: false, //是否显示用户菜单
      showSubNav: false, //是否显示子导航
      userModel: Object.assign({}, HeaderNav.DEFAULT_USER_MODEL, props.userModel)
    }, _this._parseMenu(props.menu, props.activeCode));
    return _this;
  }

  _createClass(HeaderNav, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var newState = {};
      if (nextProps.hasOwnProperty('userModel')) {
        Object.assign(newState, {
          userModel: Object.assign({}, HeaderNav.DEFAULT_USER_MODEL, nextProps.userModel)
        });
      }
      if (nextProps.hasOwnProperty('menu') || nextProps.hasOwnProperty('activeCode')) {
        Object.assign(newState, this._parseMenu(nextProps.menu, nextProps.activeCode));
      }
      this.setState(newState);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.windowEventListener('click', function (e) {
        if (_this2.state.showUserMenu && !_this2.refs.user.contains(e.target)) {
          _this2._toggleUserMenu();
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var prefixCls = _props.prefixCls;
      var logo = _props.logo;
      var onClickLogo = _props.onClickLogo;
      var theme = _props.theme;
      var user = _props.user;
      var _props$keepLogoAside = _props.keepLogoAside;
      var keepLogoAside = _props$keepLogoAside === undefined ? false : _props$keepLogoAside;
      var right = _props.right;
      var showCollapse = _props.showCollapse;
      var collapse = _props.collapse;
      var onCollapse = _props.onCollapse;

      var basicPrefixCls = prefixCls + '-header';
      var _state = this.state;
      var showSubNav = _state.showSubNav;
      var topMenu = _state.topMenu;
      var activeSubMenu = _state.activeSubMenu;
      var topActiveCode = _state.topActiveCode;
      var subActiveCode = _state.subActiveCode;


      return _react2.default.createElement(
        'div',
        { className: _util2.default.classNames(basicPrefixCls + ' ' + basicPrefixCls + '--' + theme, {
            'has-sub-nav': showSubNav,
            'logo-aside': keepLogoAside
          }) },
        _react2.default.createElement(
          'div',
          { className: basicPrefixCls + '__top-nav' },
          _react2.default.createElement(
            'div',
            { className: basicPrefixCls + '__top-nav-inner' },
            _react2.default.createElement(
              'div',
              { className: basicPrefixCls + '__left' },
              !!logo && _react2.default.createElement(
                'div',
                { className: basicPrefixCls + '__logo', onClick: onClickLogo },
                logo
              ),
              showCollapse && _react2.default.createElement(
                'div',
                { className: basicPrefixCls + '__collapse',
                  onClick: function onClick() {
                    onCollapse(!collapse);
                  } },
                _react2.default.createElement('span', { className: 'block-icon-bars' })
              )
            ),
            !!topMenu && topMenu.size > 0 && _react2.default.createElement(
              'div',
              { className: basicPrefixCls + '__top-menu' },
              this._getMenuElement(basicPrefixCls, topMenu, topActiveCode)
            ),
            _react2.default.createElement(
              'div',
              { className: basicPrefixCls + '__right' },
              right,
              !!user && this._getUserElement(basicPrefixCls)
            )
          )
        ),
        showSubNav && !!activeSubMenu && activeSubMenu.size > 0 && _react2.default.createElement(
          'div',
          { className: basicPrefixCls + '__sub-nav' },
          this._getMenuElement(basicPrefixCls, activeSubMenu, subActiveCode)
        )
      );
    }
  }, {
    key: '_getUserElement',
    value: function _getUserElement(basicPrefixCls) {
      var _this3 = this;

      var user = this.props.user;
      var _state2 = this.state;
      var showUserMenu = _state2.showUserMenu;
      var _state2$userModel = _state2.userModel;
      var idField = _state2$userModel.idField;
      var nameField = _state2$userModel.nameField;
      var avatarField = _state2$userModel.avatarField;
      var showAvatar = _state2$userModel.showAvatar;
      var showName = _state2$userModel.showName;
      var menu = _state2$userModel.menu;


      var hasMenu = !!menu && menu.length > 0;
      var menuItems = void 0;
      if (hasMenu) {
        menuItems = menu.map(function (item, i) {
          var label = item.label;
          var handler = item.handler;
          //FIXME 单击时默认让菜单收起

          return _react2.default.createElement(
            'li',
            { key: i,
              className: basicPrefixCls + '__user-menu-item',
              onClick: function onClick() {
                _this3._toggleUserMenu(false);handler && handler();
              } },
            label
          );
        });
      }

      return _react2.default.createElement(
        'div',
        { ref: 'user',
          className: _util2.default.classNames(basicPrefixCls + '__user', {
            'has-menu': hasMenu,
            'with-name': showName && !!user[nameField],
            'with-avatar': showAvatar && !!user[avatarField]
          }),
          onMouseEnter: this._toggleUserMenu.bind(this, true),
          onMouseLeave: this._toggleUserMenu.bind(this, false) },
        (showName || showAvatar) && _react2.default.createElement(
          'div',
          { className: basicPrefixCls + '__user-info' },
          showAvatar && !!user[avatarField] && _react2.default.createElement(
            'div',
            { className: basicPrefixCls + '__user-avatar' },
            (0, _lodashCompat.isString)(user[avatarField]) ? _react2.default.createElement('img', { src: user[avatarField] }) : user[avatarField]
          ),
          showName && !!user[nameField] && _react2.default.createElement(
            'div',
            { className: basicPrefixCls + '__user-name' },
            user[nameField]
          )
        ),
        showUserMenu && _react2.default.createElement(
          'div',
          { className: basicPrefixCls + '__user-menu' },
          _react2.default.createElement(
            'ul',
            { className: basicPrefixCls + '__user-menu-list' },
            menuItems
          )
        )
      );
    }
  }, {
    key: '_toggleUserMenu',
    value: function _toggleUserMenu() {
      this.setState({
        showUserMenu: !this.state.showUserMenu
      });
    }
  }, {
    key: '_getMenuElement',
    value: function _getMenuElement(basicPrefixCls, menu, activeCode) {
      var urlFor = this.props.urlFor;

      var menuList = menu.toArray().map(function (item) {
        var code = item.code;
        var label = item.label;
        var type = item.type;
        var icon = item.icon;

        var content = void 0,
            iconContent = (0, _utils.buildIcon)(icon);
        if (type == 'link') {
          content = _react2.default.createElement(
            'a',
            { href: item.url, target: item.target || '_blank', className: 'menu-item-link' },
            iconContent && _react2.default.createElement(
              'span',
              { className: 'menu-item-link__icon' },
              iconContent
            ),
            _react2.default.createElement(
              'span',
              null,
              label
            )
          );
        } else {
          content = _react2.default.createElement(
            _reactRouter.Link,
            { to: urlFor(code), className: 'menu-item-link' },
            iconContent && _react2.default.createElement(
              'span',
              { className: 'menu-item-link__icon' },
              iconContent
            ),
            _react2.default.createElement(
              'span',
              null,
              label
            )
          );
        }
        return _react2.default.createElement(
          'li',
          { key: code,
            className: _util2.default.classNames(basicPrefixCls + '__menu-item', {
              active: code == activeCode
            }) },
          content
        );
      });
      return _react2.default.createElement(
        'ul',
        { className: basicPrefixCls + '__menu-list' },
        menuList
      );
    }

    /**
     * 解析menu数据
     * @param menu
     * @param activeCode 当前激活的节点code
     * @returns {{topMenu: *, subMenu: *, topActiveCode: *, subActiveCode: *}}
     * @private
     */

  }, {
    key: '_parseMenu',
    value: function _parseMenu(menu, activeCode) {
      if (!menu || menu.size == 0) return;
      var topMenu = menu.filter(function (item) {
        return item.level == 0;
      }),
          subMenu = menu.filter(function (item) {
        return item.level == 1;
      });

      //初始化result
      var result = {
        topMenu: topMenu, subMenu: subMenu,
        showSubNav: false,
        activeSubMenu: undefined,
        topActiveCode: undefined,
        subActiveCode: undefined
      };

      if (topMenu && activeCode) {
        //如果当前激活的节点在第一层
        if (topMenu.get(activeCode)) {
          Object.assign(result, {
            topActiveCode: activeCode,
            subActiveCode: undefined
          });
          //如果第二层存在
          if (subMenu && subMenu.size > 0) {
            var activeSubMenu = subMenu.filter(function (item) {
              return item.parent == activeCode;
            });
            Object.assign(result, {
              showSubNav: activeSubMenu.size > 0,
              activeSubMenu: activeSubMenu
            });
          }
        } else if (subMenu) {
          //如果存在二级导航
          var subActiveNode = subMenu.get(activeCode);
          //如果当前激活的节点在第二层，反向找到上层激活节点
          if (subActiveNode) {
            (function () {
              var activeTopMenuItem = topMenu.get(subActiveNode.parent);
              //如果上层结点没有被隐藏
              if (!activeTopMenuItem.hide) {
                var _activeSubMenu = subMenu.filter(function (v, k) {
                  return activeTopMenuItem.children.includes(k);
                });
                Object.assign(result, {
                  showSubNav: true,
                  topActiveCode: subActiveNode.parent,
                  subActiveCode: activeCode,
                  activeSubMenu: _activeSubMenu
                });
              }
            })();
          }
        }
      }

      return result;
    }
  }]);

  return HeaderNav;
}(_util2.default.BaseComponent), _class.DEFAULT_USER_MODEL = {
  idField: 'id',
  nameField: 'name',
  avatarField: 'avatar',
  showAvatar: true,
  showName: true,
  menu: []
}, _temp);
exports.default = HeaderNav;